import React from 'react';

import AlertPanel from 'components/generic/AlertPanel.component';
import { useTranslation } from 'providers/GILT.provider';

const CashupForbidden = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="CashupForbidden" style={{ margin: '32px auto' }}>
      <AlertPanel tag="AlertPanel" variant="warningPanel">
        <div>
          {t('cashUp.cashUpForbidden.meassage1')}
          <br />
          {t('cashUp.cashUpForbidden.meassage2')}
        </div>
      </AlertPanel>
    </div>
  );
};

export default CashupForbidden;
